/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectOtherPartnerDTO
 */
export interface ProjectOtherPartnerDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectOtherPartnerDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectOtherPartnerDTO
     */
    otherPartner?: string;
}

/**
 * Check if a given object implements the ProjectOtherPartnerDTO interface.
 */
export function instanceOfProjectOtherPartnerDTO(value: object): value is ProjectOtherPartnerDTO {
    return true;
}

export function ProjectOtherPartnerDTOFromJSON(json: any): ProjectOtherPartnerDTO {
    return ProjectOtherPartnerDTOFromJSONTyped(json, false);
}

export function ProjectOtherPartnerDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectOtherPartnerDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'otherPartner': json['otherPartner'] == null ? undefined : json['otherPartner'],
    };
}

export function ProjectOtherPartnerDTOToJSON(json: any): ProjectOtherPartnerDTO {
    return ProjectOtherPartnerDTOToJSONTyped(json, false);
}

export function ProjectOtherPartnerDTOToJSONTyped(value?: ProjectOtherPartnerDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'otherPartner': value['otherPartner'],
    };
}


